import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  justify-content: center;
  min-height: 100%;
  margin: 0 auto;
  max-width: 1140px;
  width: 100%;
  padding: 0 30px;
`

export default Container
